import { Component, OnInit, AfterContentInit } from '@angular/core';
import { AuthService } from '../../app/auth.service';
import { PasswordStrengthDTO } from '../api/plyca-dtos';
import { AppState } from '../store/AppState';
import { Store } from '@ngrx/store';
import { ServiceLocator } from '../ServiceLocator';
import { AppConfiguration } from '../conf/app.configuration';
import { WaitLoadingService } from '../components/common/waitLoading/wait-loading.service';
import { clearModalsOnCloseSession } from '../app.helpers';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { BaseComponent } from '../components/common/baseComponent/base.component';
import { PlycaErrorHandler } from '../../http/PlycaErrorHandler';

@Component({
  selector: 'changepassword',
  templateUrl: 'change-password-view.template.html'
})
export class ChangePasswordViewComponent extends BaseComponent implements OnInit, AfterContentInit {
  background: any;

  private store: Store<AppState>;

  public user: string;

  public passNew: string;
  public passConfirm: string;
  public strength: string;
  private validStrengthPassword = false;
  token: string;


  errorMsg = '';
  public show_spin = -100;

  constructor(protected authService: AuthService, appConfig: AppConfiguration,
    private translate: TranslateService,
    private waitService: WaitLoadingService,
    private route: ActivatedRoute,
    private plycaErrorHandler: PlycaErrorHandler,
    private translateService: TranslateService) {
    super();
    this.store = ServiceLocator.injector.get(Store) as Store<AppState>;
  }

  ngOnInit(): void {
    // al inicializar el componte se genera el background
    this.background = this.calculateBackground();
    clearModalsOnCloseSession();

    this.subscribe(this.route.queryParams,
      params => {
        this.user = params['user'];
        this.token = params['token'];
        let locale = params['locale'];
        if (locale !== undefined) {
          this.translate.use(locale);
        }
      });
  }

  onSubmit() {
    if (!this.passNew || !(this.passConfirm === this.passNew)) {
      this.errorMsg = this.translate.instant('LoginView.change.validPassword');
    } else {
      this.show_spin = 100;
      this.subscribe(this.authService.resetPassword(this.user, this.passNew, this.token),
        (response: PasswordStrengthDTO) => {
          if (response?.valid) {
            this.errorMsg = undefined;
            this.authService.navigateToLoginRoute({ 'newpassword': true });
          } else if (response?.cause) {
            this.errorMsg = response.cause;
          } else {
            this.errorMsg = this.translate.instant('LoginView.change.error');
          }
        },
        error => {
          console.error('Error al resetear contraseña', error);
          this.errorMsg = this.translate.instant('LoginView.change.error');
        },
        () => {
          this.show_spin = -100;
        }
      );
    }
  }

  ngAfterContentInit(): void {

    this.waitService.cancelWaiting();
  }

  public calculateBackground() {
    let min = 1;
    let max = 10;
    let random = Math.floor(Math.random() * (max - min + 1) + min);
    let url = 'assets/img/bg-login' + random + '.jpeg';
    console.log('Calculando background', url);
    return {
      background: 'url(' + url + ') no-repeat'
    };
  }

  public isValidPassword(ignoreStrengthPassword = false): boolean {
    let newPassDefined = this.isNotEmpty(this.passNew);
    let confirmPassDefined = this.isNotEmpty(this.passConfirm);
    let valid = newPassDefined && confirmPassDefined
      && this.passNew === this.passConfirm
      && (ignoreStrengthPassword || this.validStrengthPassword);
    if (newPassDefined && confirmPassDefined && this.passNew !== this.passConfirm) {
      this.strength = 'different';
      this.errorMsg = this.translateService.instant('LoginView.different');
      valid = false;
    }
    return valid;
  }

  public getPasswordStrength() {
    this.errorMsg = undefined;
    this.isValidPassword(true);
    if (this.isNotEmpty(this.passNew) && this.passNew === this.passConfirm) {
      this.subscribe(this.authService.passwordStrength(this.user, this.passNew, this.token),
        (passStrength: PasswordStrengthDTO) => {
          this.strength = passStrength?.strength;
          this.validStrengthPassword = passStrength?.valid
          if (!this.validStrengthPassword && passStrength?.cause) {
            this.errorMsg = passStrength.cause;
          }
        },
        error => {
          this.plycaErrorHandler.showServerError(error);
        }
      );
    }
  }

  private isNotEmpty(text: string): boolean {
    return text !== undefined && text.trim() !== '';
  }

}
